<template>
  <Teleport to="body">
    <div v-bind="$attrs">
      <!-- Modal backdrop -->
      <transition
        enter-active-class="transition ease-out duration-200"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition ease-out duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-show="true"
          class="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-[1500] transition-opacity left-0 top-0"
          aria-hidden="true"
        ></div>
      </transition>
      <!-- Modal dialog -->
      <transition
        enter-active-class="transition ease-in-out duration-200"
        enter-from-class="opacity-0 translate-y-4"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition ease-in-out duration-200"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 translate-y-4"
      >
        <div
          v-show="true"
          ref="backDrop"
          class="fixed inset-0 z-[1500] overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
          :class="backdropClass"
          role="dialog"
          aria-modal="true"
        >
          <div
            ref="modalContent"
            :class="
              wrapperClass ||
              'bg-white dark:bg-slate-800 rounded-lg shadow-lg overflow-auto max-w-lg w-full max-h-full'
            "
          >
            <slot />
          </div>
        </div>
      </transition>
    </div>
  </Teleport>
</template>

<script lang="ts">
import { ref, onMounted, onUnmounted } from "vue";

export default {
  name: "ModalEmpty",
  props: {
    id: { type: String, required: false },
    closeOnBackgroundClick: { type: Boolean, default: true },
    wrapperClass: { type: String, required: false },
    backdropClass: { type: String, required: false },
  },
  emits: ["close-modal"],
  setup(props, { emit }) {
    const modalContent = ref<HTMLDivElement>();
    const backDrop = ref<HTMLDivElement>();

    // close on click outside
    const clickHandler = ({ target }: MouseEvent) => {
      if (modalContent.value?.contains(target as Node)) return;
      emit("close-modal");
    };

    // close if the esc key is pressed
    const keyHandler = ({ keyCode }: KeyboardEvent) => {
      if (keyCode !== 27) return;
      emit("close-modal");
    };

    onMounted(() => {
      if (!props.closeOnBackgroundClick || !backDrop.value) return;
      backDrop.value.addEventListener("click", clickHandler);
      backDrop.value.addEventListener("keydown", keyHandler);
    });

    onUnmounted(() => {
      if (!props.closeOnBackgroundClick || !backDrop.value) return;
      backDrop.value.removeEventListener("click", clickHandler);
      backDrop.value.removeEventListener("keydown", keyHandler);
    });

    return {
      modalContent,
      backDrop,
    };
  },
};
</script>
